// extracted by mini-css-extract-plugin
export var content = "_6c-3";
export var list = "_6c-4";
export var settingsContent = "_6c-7";
export var settingsPanel = "_6c-8";
export var state = "_6c-6";
export var triggerBadge = "_6c-2";
export var triggerButton = "_6c-1";
export var triggerShell = "_6c-0";
export var unreadDot = "_6c-5";